module.exports = __webpack_public_path__ + "img/length.1f4665fa.png";